import { render, staticRenderFns } from "./ModalDetailPetani.vue?vue&type=template&id=65ff5ac7"
import script from "./ModalDetailPetani.vue?vue&type=script&lang=js"
export * from "./ModalDetailPetani.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports